import { ButtonUiState } from '@/components/Common/Button/ButtonUi';
import { SellerProfileUi } from '@/components/Seller/SellerProfile/SellerProfileUi';
import { SellerDetailsResponse } from '@/data/api/model/sellers/SellersDto';
import { sellerStatusToStatusBadgeUi } from '../useGetSellers/mapper';

export function sellerDetailsResponseToSellerProfileUi(
  details: SellerDetailsResponse
): SellerProfileUi {
  return {
    title: details.name ?? '',
    isActive: sellerDetailsResponseToIsActive(details),
    moreActions: sellerDetailsResponseToMoreActions(details),
    status: sellerStatusToStatusBadgeUi(details.business_status ?? ''),
  };
}

function sellerDetailsResponseToIsActive(
  details: SellerDetailsResponse
): boolean | undefined {
  if (details.business_status === 'ACTIVE') return true;
  if (details.business_status === 'INACTIVE') return false;
}

function sellerDetailsResponseToMoreActions(
  details: SellerDetailsResponse
): ButtonUiState[] {
  const isActive = sellerDetailsResponseToIsActive(details);
  if (isActive === undefined) return [];
  return [
    {
      label: isActive ? 'Desactivar vendedor' : 'Activar vendedor',
      variant: 'text',
    },
  ];
}
